module.exports = __webpack_public_path__ + "img/usa-blood-diseases-male.1ca9d359.png";